// *******************************************************************************
// Close Info Bar
// *******************************************************************************

attachEvent('.info-bar__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.info-bar');
  parentEle.classList.add('d-xs-none');
  document.body.style.setProperty('--top-bar-height', '0px');
});
